// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import router from "./router";
import store from "./store";


//echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

export var bus = new Vue();
Vue.prototype.$bus = bus;



import "./assets/icons";
// 自定义组件全局注册
import components from "./components";
components.forEach((item) => Vue.component(item.name, item.component));

import flowComponents from './module'
Vue.use(flowComponents)
    // 引用element-ui
import "../element-variables.scss";

/* Network plugin */
import Http from "@/plugins/http";
Vue.use(Http);

/* Auth plugin */
import Auth from "@/plugins/auth";
Vue.use(Auth);

import "@/assets/icons/index";
import "@/assets/css/reset.css";
import "@/assets/js/rtportal.js";
import "./assets/css/apaas.less";
import "@/assets/css/fonts/styles.css";
import "@/assets/css/rtportal.less";



/* Privilege plugin */
import Privilege from "@/plugins/privilege";
Vue.use(Privilege);

/* Heartbeat plugin */
import Heartbeat from "@/plugins/heartbeat";
Vue.use(Heartbeat);

import moment from "vue-moment";
Vue.use(moment);

localStorage.setItem("isStore", "1");

import vueXlsxTable from "vue-xlsx-table";
Vue.use(vueXlsxTable, {
    rABS: true,
});

//自定义组件
import PortalUI from "../packages";
Vue.use(PortalUI);

// 开启debug模式
Vue.config.debug = true;
Vue.config.productionTip = false;
// 配置是否允许vue-devtools 检查代码  默认为true
Vue.config.devtools = true;

import App from "./App";
/* eslint-disable no-new */




// import Vue from 'vue';
import xpcComponents from "vue-xpc/src/components";
import VueI18n from "vue-i18n";
import rtXpc from 'vue-xpc'

// 使用 i18n；
Vue.use(VueI18n);
// 创建 i18n 实例

Vue.use(rtXpc, {
    config: {
        componentPrefix: "Rc",
        address: { autoLoad: false },
        // 默认多语言语种名称
        defaultLocale: typeof localStorage.i18nLocale == "undefined" ? "zh-CN" : localStorage.i18nLocale,
        // 默认多语言语种 id
        defaultLocaleId: typeof localStorage.i18nLocaleid == "undefined" ? "2052" : localStorage.i18nLocaleid,
        // 获取多语言语种 url
        localesUrl: "api/PortalLanguage/GetLanguageList",
        // 获取多语言语言包 url
        localesMessageUrl: "api/PortalLanguage/GetLanguageConfigs?langId=",
        // 默认无法显示图标名称
        defaultIconName: "rt-base-defaultIcon",
    }
});
import {
    locales,
    // messages
} from "./config/i18n-map";
//default language
var defaultLocale = localStorage.i18nLocale;
if (defaultLocale === null || defaultLocale === undefined) {
    defaultLocale = locales[0].value;
}
const i18n = new VueI18n({
    locale: defaultLocale, // set locale
    // messages, // set locale messages
});


Vue.i18n = i18n;
rt.setLangConfigs2(i18n);
Vue.http.interceptors.request.use(function(config) {
    const locale = Vue.i18n.locale;
    if (locale !== null && locale.length > 0) {
        config.headers["Accept-Language"] = locale;
    }
    return config;
});
// import VueKeycloakJs from "@dsb-norge/vue-keycloak-js";
Vue.prototype.$_t = (key, defaultValue) => {
    // 没有传入 key ，直接返回 defaultValue
    if (!key) return defaultValue;
    // i18n 方法存在，使用 i18nMethod 翻译
    if (i18n && i18n.t) {
        let value = i18n.t(key);
        return value || defaultValue;
    }
    return defaultValue;
};
// import VueXpc from "vue-xpc";
// Vue.use(VueXpc)
/* ui plguin */
import ElementUI from 'element-ui';
// import  'element-ui/lib/theme-chalk/index.css';
//element-ui多语言
import locale from "element-ui/lib/locale";
import format from "element-ui/lib/locale/format";
const formater = format(Vue);
//初始化elementui
Vue.use(ElementUI, {
    i18n(path, options) {
        let value = i18n.t(path);
        if (value !== null && value !== undefined) return formater(value, options);
        const array = path.split(".");
        for (let i = 0, j = array.length; i < j; i += 1) {
            const property = array[i];
            value = i18n.t(property);
            if (i === j - 1) return formater(value, options);
            if (!value) return "";
        }
        return "";
    },
});

new Vue({
    el: "#app",
    router,
    store,
    i18n,
    template: "<App/>",
    components: {
        App,
    },
});


// WEBPACK FOOTER //
// ./src/main.js